module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-ron-lach-7189449-9cec2dd6d157512ad6e7ca2eb6a0d264.jpg";